import { Alert, Col, Divider, Row, Space, Upload } from 'antd';
import useSession from 'Hooks/session.hook';
import React, { Fragment, useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { Link, useHistory } from 'react-router-dom';
import { useRecoilState } from 'recoil';
import { LocalCartAtom } from 'Recoil/order.atom';
import { InvalidVoucherStatusType } from '../purchase-list/purchase-list';
import { isNil, isEmpty, flatten, forEach, groupBy, map } from 'lodash';
import { fetchProductData } from 'Services/inventory.services';
import { encode } from 'Helpers/enc';
import { generateCode } from 'Helpers/generate-code';
import { createRePaymentObject, CreateRePaymentObjectPayload } from 'Services/payment.services';
import { BasicModal, Button, SkeletonLoader } from '@life-line-lab/components-react';
import { toaster } from 'Helpers/toaster';
import { Status, QuotationRequest } from 'Models/quotation-request'
import moment from 'moment';
import './prescription-list.scss';
import { fetchQuotation } from 'Services/quotation.services';

interface PrescriptionListProps {
  status: any;
  prescriptionDataList: QuotationRequest[];
}

const PrescriptionList = ({ status, prescriptionDataList }: PrescriptionListProps) => {
  const { t } = useTranslation();
  const history = useHistory();
  const [localCartState, setLocalCartState] = useRecoilState<any>(LocalCartAtom);
  const { profile } = useSession();

  useEffect(() => {
    if (!profile) {
      history.push('/login');
    }
  }, [profile]);


  return (
    <div className="product payment-list prescription-list">
      {status.fetch == 'loading' && (
        <>
          <SkeletonLoader type="default" />
          <SkeletonLoader type="default" />
          <SkeletonLoader type="default" />
        </>
      )}

      <Row gutter={16}>
        <Col lg={24} md={24} sm={24} xs={24}>
          {prescriptionDataList.length && status.fetch !== 'loading' ? (
            <Alert
              type="info"
              showIcon
              message={
                <Fragment>
                  <span>{t('txt.orderQueries')}</span>
                  <Link
                    style={{ marginRight: '3px', marginLeft: '3px', color: '#B42C30' }}
                    to="/support"
                  >
                    {t('txt.contactSupport')}
                  </Link>
                  <span> {t('txt.forAssistance')}</span>
                </Fragment>
              }
            />
          ) : (
            ''
          )}
        </Col>
        <Col lg={24} md={24} sm={24} xs={24}>
          {prescriptionDataList.length && status.fetch !== 'loading'
            ? prescriptionDataList.map((quotationRequest, i) => {
                return (
                  <div key={i} className="payment-wrapper px-15">
                    <div className="py-10 mb-10 primary-title prescription-list__header-row">
                      <div className=''>
                        {quotationRequest.code}
                      </div>
                      <div className=' px-5'>
                        {
                          quotationRequest.files && 
                          <div>
                            <span className="view-receipt">{t('label.prescriptionDocument')}</span>
                            <Upload
                              defaultFileList={quotationRequest.files_data.map((fd, fIdx) => ({
                                uid: '' + fIdx,
                                name: fd.fileName,
                                status: 'done',
                                url: fd.file_url,
                              }))}
                              disabled
                              listType='text'
                            />
                          </div>
                        }
                      </div>
                    </div>
                    <Row gutter={8} className="primary-title">
                      {/* <Col xs={24} md={12} lg={8}>
                        {quotationRequest.files && <a className="view-receipt" onClick={() => { viewPrescription(quotationRequest.files) }}>{t('action.downloadPrescriptionDocument')}</a>}
                      </Col> */}
                      <Col xs={24} md={12} lg={8}>
                        {t('label.createdDate')}:{' '}
                        {moment(quotationRequest.createdAt).format('YYYY-MM-DD')}
                      </Col>
                      <Col xs={24} md={12} lg={8}>
                        {t('label.status')}: <span className='color-secondary'>{quotationRequest.status}</span>
                      </Col>
                    </Row>
                    <div className="">
                      {
                        isEmpty(quotationRequest.quotations) &&
                        <div className='no-quotations'>
                          {t('txt.noQuotations')}
                        </div>
                      }
                      {quotationRequest?.quotations &&
                        quotationRequest.quotations.map((o, i) => {
                          return (
                            <div className="shopping-details my-20">
                              <Col lg={24} md={24} sm={24} xs={24}>
                                <div className="cart-table">
                                  <div>
                                    <div className="purchase-section1">
                                      <Row gutter={16} className="rrow">
                                        <Col lg={1} md={1} sm={1} xs={0} className="ccol"></Col>

                                        <Col
                                          lg={4}
                                          md={4}
                                          sm={8}
                                          xs={24}
                                          className="ccol flex-align-center"
                                        >
                                          <Row gutter={16}>
                                            <Col xs={24}>
                                              <div className="title">#{o.code}</div>
                                            </Col>
                                          </Row>
                                        </Col>
                                        {/* <Col
                                          lg={4}
                                          md={4}
                                          sm={8}
                                          xs={12}
                                          className="ccol flex-align-center"
                                          >
                                        </Col> */}
                                      </Row>

                                      <Row gutter={16}>
                                        <Col lg={20} md={20} sm={20} xs={24} className="ccol">
                                          {o.items.map((record, j) => {
                                            // TODO
                                            const fileID = record.itemData.product.productVariants?.find(pv => pv.variantCode === record.variantCode)?.images?.[0]?.fileID ?? record.itemData?.product?.images?.[0]?.fileID;
                                            let itemImage =
                                              record.itemData?.files_data?.find(fd => fd._id === fileID)?.file_url ||
                                              '/assets/images/product-placeholder.png';
                                            // const variantCode = record.variantCode;
                                            // if (
                                            //   variantCode &&
                                            //   record.itemData?.product?.images?.length
                                            // ) {
                                            //   const matchedImageLink =
                                            //     record.itemData?.product?.images.find(
                                            //       (elem) => elem.variantCode === variantCode,
                                            //     );
                                            //   if (matchedImageLink) {
                                            //     itemImage =
                                            //       matchedImageLink.file_data?.file_url || itemImage;
                                            //   }
                                            // }

                                            return (
                                              <Row
                                                gutter={16}
                                                className={
                                                  'image-section ' + (o.status == 'OPEN' ? '' : '')
                                                }
                                              >
                                                <Col
                                                  lg={1}
                                                  md={1}
                                                  sm={1}
                                                  xs={0}
                                                  className="ccol"
                                                ></Col>
                                                <Col
                                                  lg={3}
                                                  md={3}
                                                  sm={3}
                                                  xs={6}
                                                  className="ccol flex-align-center"
                                                >
                                                  <img
                                                    alt={t('alt.logo')}
                                                    src={itemImage}
                                                    style={{ width: '100%' }}
                                                    onError={({ currentTarget }) => {
                                                      currentTarget.onerror = null; // prevents looping
                                                      currentTarget.src =
                                                        '/assets/images/product-placeholder.png';
                                                    }}
                                                  />{' '}
                                                  &nbsp;
                                                </Col>
                                                <Col
                                                  lg={12}
                                                  md={12}
                                                  sm={12}
                                                  xs={12}
                                                  className="ccol info"
                                                >
                                                  <div
                                                    style={{
                                                      textTransform: 'capitalize',
                                                      fontSize: '16px',
                                                    }}
                                                  >
                                                    {' '}
                                                    <strong>{record.itemData?.product.name}</strong>
                                                  </div>
                                                  <h5 className="color-secondary">
                                                    <strong>
                                                      ({record.variant}) x {record.quantity}
                                                    </strong>
                                                  </h5>
                                                  <h4 className="color-secondary">
                                                    <strong>
                                                      RM {parseFloat(record.unitPrice).toFixed(2)}
                                                    </strong>
                                                  </h4>
                                                </Col>
                                              </Row>
                                            );
                                          })}
                                        </Col>
                                        <Col lg={4} md={4} sm={4} xs={24} className="canceBtn">
                                          <Row>
                                            <Col
                                              lg={24}
                                              md={24}
                                              sm={24}
                                              xs={24}
                                              className="py-5 px-5"
                                            >
                                              {
                                                o.status === Status.OPEN &&
                                                <Button
                                                  type="primary"
                                                  style={{ width: '100%' }}
                                                  label={t('action.placeOrder')}
                                                  size="large"
                                                  onClick={() => {
                                                    history.push(`/checkout?quotationID=${encode(o._id as string)}`)
                                                  }}
                                                />
                                              }
                                              {
                                                o.file &&
                                                <Button
                                                  type="secondary"
                                                  style={{ width: '100%' }}
                                                  label={t('action.downloadQuotation')}
                                                  size="large"
                                                  onClick={async () => {
                                                    const quotationResponse = await fetchQuotation({
                                                      _id: o._id as string,
                                                    })
                                                    if (!quotationResponse || quotationResponse.error) return;
                                                    window.open(quotationResponse.file_data?.file_url, '_blank')
                                                  }}
                                                />
                                              }
                                            </Col>
                                          </Row>
                                        </Col>
                                      </Row>
                                      <div>
                                        <Row gutter={16} className="order-total">
                                          <Col span={12} xs={12}>
                                            {' '}
                                            {t('txt.soldby')} : {o.quotedByData?.name}{' '}
                                          </Col>
                                          <Col span={12} xs={12} className="text-end">
                                            {' '}
                                            {t('txt.orderTotal')} : RM
                                            {parseFloat(o.paymentDetails?.total as string).toFixed(
                                              2,
                                            )}
                                          </Col>
                                        </Row>
                                      </div>
                                    </div>
                                  </div>
                                </div>
                              </Col>
                            </div>
                          );
                        })}
                    </div>
                    <Row
                      gutter={16}
                      style={{ borderBottom: '1px solid #ddd', borderRadius: '6px' }}
                    ></Row>
                  </div>
                );
              })
            : status.fetch == 'success' && (
                <Row>
                  <div className="my-10 m-auto justify-center">
                    <div>
                      <img
                        className="mx-25"
                        alt={t('alt.logo')}
                        src="/assets/images/empty-order.png"
                        width={150}
                      />
                      <h3 className="color-primary">
                        <strong>{t('txt.noPurchaseHistoryFound')}</strong>
                      </h3>
                    </div>
                  </div>
                </Row>
              )}
        </Col>
      </Row>
    </div>
  );
};

export default PrescriptionList;
